import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getEntities as getFreezeRequestsList, getEntitiesByCardId as getFreezeRequestsByCardId, } from 'shared/lib/reducers/card-freeze-request.reducer';
import { getEntities as getUnfreezeRequestsList, getEntitiesByCardId as getUnfreezeRequestsByCardId, approveRequest as approveUnfreezeRequestThunk, } from 'shared/lib/reducers/card-unfreeze-request.reducer';
import { translate } from 'i18n/jhipster-language';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import PRow from 'shared/ui/prow';
import { APP_LOCAL_DATETIME_FORMAT, ROWS_PER_PAGE } from 'app/config/constants';
import { cmsHttp } from 'shared/api/mfe-axios';
import { getCmsAccountApproverId } from 'shared/lib/cms-account-approver';
import { isTableSkeletonRow, TABLE_SKELETON_ROW_COUNT, tableActionButtonsSkeleton, tableCellSkeleton, } from 'shared/ui/table-skeleton';
import moment from 'moment';
import CardRequestCreateDialog from './card-request-create-dialog';
import CardStatusRequestDetails from './card-status-request-details';
import { CARD_REQUEST_SOURCE_OPTIONS, } from 'shared/lib/card-request-form.constants';
import { validateOptionalCardId, validateOptionalFilterText, } from 'shared/lib/validation/search-filters';
import { FIELD_CONSTRAINTS } from 'shared/lib/validation/field-constraints';
const buildSkeletonRows = () => Array.from({ length: TABLE_SKELETON_ROW_COUNT }, (_, i) => ({ id: -(i + 1) }));
const formatDt = (v) => (v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '');
const STATUS_REQUEST_FILTER_OPTIONS = [
    'REQUESTED',
    'ACTIVE',
    'PENDING_APPROVAL',
    'SUBMITTED',
    'APPROVED',
    'REJECTED',
    'CANCELLED',
    'CLOSED',
].map(v => ({ name: v, value: v }));
const emptyStatusRequestFilters = () => ({
    cardId: '',
    performedBy: '',
    sourceChannel: null,
    status: null,
    freezeReason: null,
    unfreezeReason: '',
});
function buildStatusRequestQueryFilters(kind, applied, options) {
    const out = {};
    if (options.includeCardId) {
        const id = applied.cardId.trim();
        if (id)
            out['cardId.equals'] = Number(id);
    }
    const pb = applied.performedBy.trim();
    if (pb)
        out['performedBy.contains'] = pb;
    if (applied.sourceChannel)
        out['sourceChannel.equals'] = applied.sourceChannel;
    if (applied.status)
        out['status.equals'] = applied.status;
    if (kind === 'freeze' && applied.freezeReason) {
        out['reason.equals'] = applied.freezeReason;
    }
    if (kind === 'unfreeze') {
        const ur = applied.unfreezeReason.trim();
        if (ur)
            out['unfreezeReason.contains'] = ur;
    }
    return out;
}
function useStatusRequestListFilterState(kind, includeCardId) {
    const [draft, setDraft] = useState(emptyStatusRequestFilters);
    const [applied, setApplied] = useState(emptyStatusRequestFilters);
    const cardIdError = includeCardId ? validateOptionalCardId(draft.cardId) : null;
    const performedByError = validateOptionalFilterText(draft.performedBy);
    const unfreezeReasonError = kind === 'unfreeze' ? validateOptionalFilterText(draft.unfreezeReason) : null;
    const searchDisabled = !!(cardIdError || performedByError || unfreezeReasonError);
    const patchDraft = useCallback((p) => {
        setDraft(d => ({ ...d, ...p }));
    }, []);
    const commitSearch = useCallback(() => {
        const cidErr = includeCardId ? validateOptionalCardId(draft.cardId) : null;
        const pbErr = validateOptionalFilterText(draft.performedBy);
        const urErr = kind === 'unfreeze' ? validateOptionalFilterText(draft.unfreezeReason) : null;
        if (cidErr || pbErr || urErr)
            return false;
        setApplied({ ...draft });
        return true;
    }, [draft, includeCardId, kind]);
    const handleClear = useCallback(() => {
        const e = emptyStatusRequestFilters();
        setDraft(e);
        setApplied(e);
    }, []);
    return {
        draft,
        applied,
        patchDraft,
        commitSearch,
        handleClear,
        searchDisabled,
        cardIdError,
        performedByError,
        unfreezeReasonError,
    };
}
const filterFieldStyle = { flex: '0 0 auto', width: '11rem', maxWidth: '100%' };
const CardStatusRequestsFilterBar = ({ idPrefix, kind, showCardId, draft, patchDraft, onSearch, onClear, searchDisabled, cardIdError, performedByError, unfreezeReasonError, }) => {
    const [expanded, setExpanded] = useState(false);
    return (_jsxs("div", { className: "acc-adv-search w-full", children: [_jsx("div", { className: "flex align-items-center justify-content-end gap-1", children: _jsx(Button, { type: "button", label: translate('general.advancedSearch.toggle'), icon: "pi pi-filter", className: "p-button-sm p-button-primary", onClick: () => setExpanded(v => !v) }) }), expanded && (_jsx("div", { className: "acc-adv-search__panel mt-2", children: _jsxs("div", { className: "grid acc-grid", children: [_jsxs("div", { className: "col-12 md:col-6 xl:col-3", children: [_jsx("label", { className: "acc-label", htmlFor: `${idPrefix}-performed-by`, children: translate('form.performedBy') }), _jsx(InputText, { id: `${idPrefix}-performed-by`, className: "w-full", value: draft.performedBy, onChange: e => patchDraft({ performedBy: e.target.value }), invalid: !!performedByError, placeholder: translate('form.performedBy'), maxLength: FIELD_CONSTRAINTS.TEXT_MAX }), performedByError ? _jsx("small", { className: "p-error", children: performedByError }) : null] }), _jsxs("div", { className: "col-12 md:col-6 xl:col-3", children: [_jsx("label", { className: "acc-label", htmlFor: `${idPrefix}-source`, children: translate('form.sourceChannel') }), _jsx(Dropdown, { inputId: `${idPrefix}-source`, className: "w-full", value: draft.sourceChannel, options: CARD_REQUEST_SOURCE_OPTIONS, optionLabel: "name", optionValue: "value", showClear: true, placeholder: translate('form.sourceChannel'), onChange: e => patchDraft({ sourceChannel: e.value ?? null }) })] }), _jsxs("div", { className: "col-12 md:col-6 xl:col-3", children: [_jsx("label", { className: "acc-label", htmlFor: `${idPrefix}-status`, children: translate('form.status') }), _jsx(Dropdown, { inputId: `${idPrefix}-status`, className: "w-full", value: draft.status, options: STATUS_REQUEST_FILTER_OPTIONS, optionLabel: "name", optionValue: "value", showClear: true, placeholder: translate('form.status'), onChange: e => patchDraft({ status: e.value ?? null }) })] }), _jsx("div", { className: "col-12", children: _jsxs("div", { className: "acc-actions p-d-flex p-jc-end p-mr-3", style: { gap: '0.5rem' }, children: [_jsx(Button, { type: "button", icon: "pi pi-times", label: translate('general.reset'), className: "p-button-outlined p-button-sm w-full sm:w-auto", onClick: onClear }), _jsx(Button, { type: "button", icon: "pi pi-search", label: translate('general.search'), className: "p-button-sm w-full sm:w-auto", onClick: onSearch, disabled: searchDisabled })] }) })] }) }))] }));
};
const CardStatusRequestsTab = ({ kind, scope, cardId, entities, totalItems, loading, approveActiveRow, serverPagination, filterHeader, }) => {
    const [showCreate, setShowCreate] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const requestKindDialog = kind;
    const reasonHeader = kind === 'freeze' ? translate('form.freezeReason') : translate('form.unfreezeReason');
    const createLabel = kind === 'freeze'
        ? translate('entity.action.makeFreezeRequest')
        : translate('entity.action.create', { entity: translate('form.cardUnfreezeRequest') });
    const actionSkeletonCount = kind === 'freeze' ? 1 : 2;
    const approveBtnClass = scope === 'list' ? 'p-button-info p-mx-1' : 'p-button-primary p-mx-1';
    const reasonBody = (row) => {
        if (isTableSkeletonRow(row))
            return tableCellSkeleton();
        if (kind === 'freeze')
            return row.reason ?? '';
        return row.unfreezeReason ?? row.reason ?? '';
    };
    const actionBodyTemplate = (rowData) => isTableSkeletonRow(rowData) ? (tableActionButtonsSkeleton({ buttonCount: actionSkeletonCount })) : (_jsxs(PRow, { children: [rowData.status === 'ACTIVE' && (_jsx(Button, { icon: "pi pi-check", className: approveBtnClass, onClick: () => approveActiveRow(rowData) })), _jsx(Button, { icon: "pi pi-eye", className: "p-button-primary p-mx-1", onClick: () => setViewRow(rowData) })] }));
    const tableValue = loading ? buildSkeletonRows() : entities.slice();
    const createButton = (_jsx(Button, { type: "button", label: createLabel, icon: "pi pi-plus", className: "p-button-primary", onClick: () => setShowCreate(true) }));
    const tableHeader = (_jsx("div", { className: "w-full", children: _jsxs("div", { className: "p-d-flex p-jc-between p-ai-center", style: { gap: '0.5rem', flexWrap: 'wrap' }, children: [_jsx("div", { className: "p-d-flex p-ai-center", children: createButton }), filterHeader] }) }));
    const dataTableClass = scope === 'list' ? (filterHeader ? 'mt-2' : 'mt-5') : filterHeader ? 'mt-2' : undefined;
    return (_jsxs(_Fragment, { children: [_jsxs(DataTable, { dataKey: "id", lazy: true, value: tableValue, header: tableHeader, first: serverPagination.first, paginator: !loading && totalItems > serverPagination.rows, rows: serverPagination.rows, totalRecords: totalItems, onPage: serverPagination.onPage, selectionMode: "single", isDataSelectable: e => !isTableSkeletonRow(e.data), resizableColumns: true, className: dataTableClass, emptyMessage: translate('general.dtEmptymessage'), children: [_jsx(Column, { field: 'card.maskedPan', header: translate('form.maskedPan'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : row.card?.maskedPan ?? '') }), _jsx(Column, { field: "card.cardHolderName", header: translate('form.cardHolderName'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : row.card?.cardHolderName ?? '') }), _jsx(Column, { field: "sourceChannel", header: translate('form.sourceChannel'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : row.sourceChannel ?? '') }), _jsx(Column, { field: "performedBy", header: translate('form.performedBy'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : row.performedBy ?? '') }), _jsx(Column, { field: kind === 'freeze' ? 'reason' : 'unfreezeReason', header: reasonHeader, body: reasonBody }), _jsx(Column, { field: "status", header: translate('form.status'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : row.status ?? '') }), _jsx(Column, { field: "requestedAt", header: translate('form.requestedAt'), body: row => (isTableSkeletonRow(row) ? tableCellSkeleton() : formatDt(row.requestedAt ?? undefined)) }), _jsx(Column, { style: { width: '120px' }, header: translate('general.actions'), body: actionBodyTemplate })] }), _jsx(Dialog, { contentStyle: { borderRadius: '10px', overflowX: 'visible', maxHeight: '90vh' }, showHeader: false, style: { width: '90vw', maxWidth: '720px' }, visible: showCreate, onHide: () => setShowCreate(false), children: _jsx(CardRequestCreateDialog, { requestKind: requestKindDialog, active: showCreate, ...(cardId != null ? { cardId } : {}), closeDialog: () => setShowCreate(false) }) }), _jsx(Dialog, { showHeader: false, style: { width: '60vw' }, visible: !!viewRow, onHide: () => setViewRow(null), children: viewRow ? (_jsx(CardStatusRequestDetails, { kind: kind, closeDialog: () => setViewRow(null), current: viewRow })) : null })] }));
};
const freezeListMapState = ({ cardFreezeRequest }) => ({
    entities: cardFreezeRequest.entities,
    totalItems: cardFreezeRequest.totalItems,
    updateSuccess: cardFreezeRequest.updateSuccess,
    loading: cardFreezeRequest.loading,
});
const freezeListMapDispatch = {
    getFreezeRequests: getFreezeRequestsList,
};
const CardFreezeRequestsListTabPresenter = ({ entities, totalItems, updateSuccess, loading, getFreezeRequests, }) => {
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const filter = useStatusRequestListFilterState('freeze', true);
    const loadRequests = useCallback(() => {
        const extras = buildStatusRequestQueryFilters('freeze', filter.applied, { includeCardId: true });
        getFreezeRequests({ page, size: ROWS_PER_PAGE, ...extras });
    }, [getFreezeRequests, page, filter.applied]);
    useEffect(() => {
        loadRequests();
    }, [loadRequests]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        loadRequests();
    }, [updateSuccess, loadRequests]);
    const approveActiveRow = async (rowData) => {
        try {
            const approverId = await getCmsAccountApproverId();
            await cmsHttp().post(`api/card-freeze-requests/${rowData.id}/approve`, null, {
                params: { approverId },
            });
            loadRequests();
        }
        catch (error) {
            console.error('Freeze approval failed:', error);
        }
    };
    return (_jsx(CardStatusRequestsTab, { kind: "freeze", scope: "list", entities: entities, totalItems: totalItems, loading: loading, approveActiveRow: approveActiveRow, filterHeader: _jsx(CardStatusRequestsFilterBar, { idPrefix: "card-freeze-requests-list", kind: "freeze", showCardId: true, draft: filter.draft, patchDraft: filter.patchDraft, onSearch: () => {
                if (!filter.commitSearch())
                    return;
                setPage(0);
                setFirst(0);
            }, onClear: () => {
                filter.handleClear();
                setPage(0);
                setFirst(0);
            }, searchDisabled: filter.searchDisabled, cardIdError: filter.cardIdError, performedByError: filter.performedByError, unfreezeReasonError: filter.unfreezeReasonError }), serverPagination: {
            first,
            rows: ROWS_PER_PAGE,
            onPage: e => {
                setFirst(e.first ?? 0);
                setPage(e.page ?? 0);
            },
        } }));
};
export const CardFreezeRequestsTab = connect(freezeListMapState, freezeListMapDispatch)(CardFreezeRequestsListTabPresenter);
const freezeCardMapState = freezeListMapState;
const freezeCardMapDispatch = {
    getFreezeRequestsByCardId,
};
const CardFreezeRequestTabPresenter = ({ cardId, entities, totalItems, updateSuccess, loading, getFreezeRequestsByCardId, }) => {
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const filter = useStatusRequestListFilterState('freeze', false);
    useEffect(() => {
        setPage(0);
        setFirst(0);
        filter.handleClear();
    }, [cardId]);
    const loadRequests = useCallback(() => {
        if (!cardId)
            return;
        const extras = buildStatusRequestQueryFilters('freeze', filter.applied, { includeCardId: false });
        getFreezeRequestsByCardId(cardId, { page, size: ROWS_PER_PAGE, ...extras });
    }, [cardId, getFreezeRequestsByCardId, page, filter.applied]);
    useEffect(() => {
        loadRequests();
    }, [loadRequests]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        loadRequests();
    }, [updateSuccess, loadRequests]);
    const approveActiveRow = async (rowData) => {
        try {
            const approverId = await getCmsAccountApproverId();
            await cmsHttp().post(`api/card-freeze-requests/${rowData.id}/approve`, null, {
                params: { approverId },
            });
            loadRequests();
        }
        catch (error) {
            console.error('Freeze approval failed:', error);
        }
    };
    return (_jsx(CardStatusRequestsTab, { kind: "freeze", scope: "card", cardId: cardId, entities: entities, totalItems: totalItems, loading: loading, approveActiveRow: approveActiveRow, filterHeader: _jsx(CardStatusRequestsFilterBar, { idPrefix: `card-freeze-requests-card-${cardId}`, kind: "freeze", showCardId: false, draft: filter.draft, patchDraft: filter.patchDraft, onSearch: () => {
                if (!filter.commitSearch())
                    return;
                setPage(0);
                setFirst(0);
            }, onClear: () => {
                filter.handleClear();
                setPage(0);
                setFirst(0);
            }, searchDisabled: filter.searchDisabled, cardIdError: filter.cardIdError, performedByError: filter.performedByError, unfreezeReasonError: filter.unfreezeReasonError }), serverPagination: {
            first,
            rows: ROWS_PER_PAGE,
            onPage: e => {
                setFirst(e.first ?? 0);
                setPage(e.page ?? 0);
            },
        } }));
};
export const CardFreezeRequestTab = connect(freezeCardMapState, freezeCardMapDispatch)(CardFreezeRequestTabPresenter);
const unfreezeListMapState = ({ cardUnfreezeRequest }) => ({
    entities: cardUnfreezeRequest.entities,
    totalItems: cardUnfreezeRequest.totalItems,
    updateSuccess: cardUnfreezeRequest.updateSuccess,
    loading: cardUnfreezeRequest.loading,
});
const unfreezeListMapDispatch = {
    getUnfreezeRequests: getUnfreezeRequestsList,
    approveUnfreezeRequest: approveUnfreezeRequestThunk,
};
const CardUnfreezeRequestsListTabPresenter = ({ entities, totalItems, updateSuccess, loading, getUnfreezeRequests, approveUnfreezeRequest, }) => {
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const filter = useStatusRequestListFilterState('unfreeze', true);
    const loadRequests = useCallback(() => {
        const extras = buildStatusRequestQueryFilters('unfreeze', filter.applied, { includeCardId: true });
        getUnfreezeRequests({ page, size: ROWS_PER_PAGE, ...extras });
    }, [getUnfreezeRequests, page, filter.applied]);
    useEffect(() => {
        loadRequests();
    }, [loadRequests]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        loadRequests();
    }, [updateSuccess, loadRequests]);
    const approveActiveRow = async (rowData) => {
        if (rowData.id == null) {
            return;
        }
        try {
            const approverId = await getCmsAccountApproverId();
            await approveUnfreezeRequest(rowData.id, approverId);
            loadRequests();
        }
        catch (error) {
            console.error('Unfreeze approval failed:', error);
        }
    };
    return (_jsx(CardStatusRequestsTab, { kind: "unfreeze", scope: "list", entities: entities, totalItems: totalItems, loading: loading, approveActiveRow: approveActiveRow, filterHeader: _jsx(CardStatusRequestsFilterBar, { idPrefix: "card-unfreeze-requests-list", kind: "unfreeze", showCardId: true, draft: filter.draft, patchDraft: filter.patchDraft, onSearch: () => {
                if (!filter.commitSearch())
                    return;
                setPage(0);
                setFirst(0);
            }, onClear: () => {
                filter.handleClear();
                setPage(0);
                setFirst(0);
            }, searchDisabled: filter.searchDisabled, cardIdError: filter.cardIdError, performedByError: filter.performedByError, unfreezeReasonError: filter.unfreezeReasonError }), serverPagination: {
            first,
            rows: ROWS_PER_PAGE,
            onPage: e => {
                setFirst(e.first ?? 0);
                setPage(e.page ?? 0);
            },
        } }));
};
export const CardUnfreezeRequestsTab = connect(unfreezeListMapState, unfreezeListMapDispatch)(CardUnfreezeRequestsListTabPresenter);
const unfreezeCardMapDispatch = {
    getUnfreezeRequestsByCardId,
    approveUnfreezeRequest: approveUnfreezeRequestThunk,
};
const CardUnfreezeRequestTabPresenter = ({ cardId, entities, totalItems, updateSuccess, loading, getUnfreezeRequestsByCardId, approveUnfreezeRequest, }) => {
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const filter = useStatusRequestListFilterState('unfreeze', false);
    useEffect(() => {
        setPage(0);
        setFirst(0);
        filter.handleClear();
    }, [cardId]);
    const loadRequests = useCallback(() => {
        if (!cardId)
            return;
        const extras = buildStatusRequestQueryFilters('unfreeze', filter.applied, { includeCardId: false });
        getUnfreezeRequestsByCardId(cardId, { page, size: ROWS_PER_PAGE, ...extras });
    }, [cardId, getUnfreezeRequestsByCardId, page, filter.applied]);
    useEffect(() => {
        loadRequests();
    }, [loadRequests]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        loadRequests();
    }, [updateSuccess, loadRequests]);
    const approveActiveRow = async (rowData) => {
        if (rowData.id == null) {
            return;
        }
        try {
            const approverId = await getCmsAccountApproverId();
            await approveUnfreezeRequest(rowData.id, approverId);
            loadRequests();
        }
        catch (error) {
            console.error('Unfreeze approval failed:', error);
        }
    };
    return (_jsx(CardStatusRequestsTab, { kind: "unfreeze", scope: "card", cardId: cardId, entities: entities, totalItems: totalItems, loading: loading, approveActiveRow: approveActiveRow, filterHeader: _jsx(CardStatusRequestsFilterBar, { idPrefix: `card-unfreeze-requests-card-${cardId}`, kind: "unfreeze", showCardId: false, draft: filter.draft, patchDraft: filter.patchDraft, onSearch: () => {
                if (!filter.commitSearch())
                    return;
                setPage(0);
                setFirst(0);
            }, onClear: () => {
                filter.handleClear();
                setPage(0);
                setFirst(0);
            }, searchDisabled: filter.searchDisabled, cardIdError: filter.cardIdError, performedByError: filter.performedByError, unfreezeReasonError: filter.unfreezeReasonError }), serverPagination: {
            first,
            rows: ROWS_PER_PAGE,
            onPage: e => {
                setFirst(e.first ?? 0);
                setPage(e.page ?? 0);
            },
        } }));
};
export const CardUnfreezeRequestTab = connect(unfreezeListMapState, unfreezeCardMapDispatch)(CardUnfreezeRequestTabPresenter);
